import { AdminAuditLogService } from './api/AdminAuditLogService'
import { AuditLogModelData } from './models/AuditLogModel'

const AuditLogModule = {
  namespaced: true,
  state: AuditLogModelData(),
  getters: {
    fetchAuditLogList: state => state.auditLogList,
    fetchQueryParams: state => state.queryParams
  },
  mutations: {
    setAuditLogList (state, data) {
      state.auditLogList = data.list
    },
    addQueryParams (state, queryParams) {
      state.queryParams = queryParams
    }
  },
  actions: {
    /**
     * Get Audit log list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getAuditLogList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAuditLogService.fetchAuditLogList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setAuditLogList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAuditLogList', {
            list: data.list
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getAuditFilterslList ({ dispatch, commit }, { resolve, reject }) {
      try {
        const response = await AdminAuditLogService.fetchAuditFilterslList()
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getAdoptionAcivityLogForDashbrd ({ dispatch, commit }, { resolve, reject }) {
      try {
        const response = await AdminAuditLogService.fetchAdoptionAcivityLogForDashbrd()
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default AuditLogModule
